import React from 'react';
import { motion } from 'framer-motion';
import { SlideFrame } from '../deck/SlideFrame';
import { SnakkerMark } from '../deck/SnakkerMark';
export function TitleSlide() {
  return <SlideFrame marker="Snakker thoughts-material" meta="Illustrative example · Psoriasis topicals" data-id="element-156" data-mp="gc3zscvs4tz5">
      <div className="flex min-h-0 flex-1 flex-col justify-center" data-id="element-157" data-mp="cb0idly32pvt">
        <SnakkerMark size="lg" showLabel={false} data-id="element-158" data-mp="c8o35gjpmtmg" />
        <p className="mt-[2vh] text-[clamp(10px,1.15vw,18px)] font-semibold uppercase tracking-[0.25em] text-gapAccent" data-id="element-159" data-mp="7bxngubti01k">
          Thoughts-material · LEO Pharma
        </p>
        <h1 className="mt-[1.6vh] font-display text-[clamp(32px,5.4vw,98px)] leading-[1.02] tracking-[-0.005em] text-ink" data-id="element-160" data-mp="3tim7e5xvp0et">
          Find the gap.
          <br data-id="element-161" data-mp="3piv8tg241fzq" />
          Then decide whether it is a{' '}
          <span className="text-gapAccent" data-id="element-162" data-mp="1rs10eyczd2c7">teaching</span> job
          <br data-id="element-163" data-mp="1rpesgxm6gktg" />
          or a <span className="text-gapAccent" data-id="element-164" data-mp="1npxlu0v0lhmp">finding</span> job.
        </h1>
        <p className="mt-[2.4vh] max-w-[52ch] text-[clamp(13px,1.5vw,25px)] leading-[1.4] text-ink-soft" data-id="element-165" data-mp="1nnt8ytf518aa">
          How we work when we start on a new brand — and how we decide where the
          money goes.
        </p>

        <motion.div className="mt-[3vh] flex flex-wrap items-center gap-[1.5%] border-t border-ink-line pt-[2vh]" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-166" data-mp="mqkero3ctiih">
          {['Prescription criteria', 'HCP perception', 'Internal fact base', 'Gap model'].map(item => <span key={item} className="rounded-2xl border border-ink-line bg-paper-card px-[1.6vw] py-[1.2vh] text-[clamp(10px,1.1vw,18px)] font-medium text-ink" data-id="element-167" data-mp="15on5c7bjvnie">
              {item}
            </span>)}
        </motion.div>
      </div>
    </SlideFrame>;
}